import { styled } from '../theme';

const Section = styled('section')(({ theme }) => ({
    display: 'flex',
    flexFlow: 'column',
    maxWidth: 1110,
    margin: '0 auto',
    padding: '150px 100px',
    [theme.media.tablet]: {
        padding: '80px 100px',
    },
    [theme.media.mobile]: {
        padding: '40px 25px',
    },
}));

export default Section;
